import { Table } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Column from "antd/es/table/Column";
import OptionsImg from "@/assets/icons/web_Icons/more.svg";
import "@/assets/styles/custom_table.css";

const SingleManifestoTable = ({ setSelectedCampaign, events }) => {
  // Transform events data for table
  const tableData =
    events?.map((event) => ({
      key: event._id,
      percentage: 71, // You might want to calculate this based on some criteria
      id: event.id,
      title: event.name,
      publishDate: new Date(event.createdAt).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
      }),
      duration: {
        startDate: event.schedule?.startDate || "",
        startTime: event.schedule?.startTime || "",
        endDate: event.schedule?.endDate || "",
        endTime: event.schedule?.endTime || "",
      },
      status: "On Going", // You might want to calculate this based on dates
    })) || [];

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedCampaign(selectedRowKeys);
    },
  };

  return (
    <Table
      rowSelection={{
        type: "checkbox",
        ...rowSelection,
      }}
      dataSource={tableData}
      pagination={false}>
      <Column
        title="Percentage"
        dataIndex="percentage"
        key="percentage"
        render={(_, { id, percentage }) => (
          <Link
            to={`/dashboard/events/${id}`}
            className="relative flex-shrink-0 block w-14 h-14 sm:w-16 sm:h-16">
            <svg className="w-full h-full transform -rotate-90">
              <circle
                cx="50%"
                cy="50%"
                r="45%"
                stroke="#E5E7EB"
                strokeWidth="4"
                fill="none"
              />
              <circle
                cx="50%"
                cy="50%"
                r="45%"
                stroke="#1890FF"
                strokeWidth="4"
                fill="none"
                strokeDasharray={175.93}
                strokeDashoffset={175.93 * (1 - percentage / 100)}
              />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-base font-semibold sm:text-lg text-primary">
                {percentage}%
              </span>
            </div>
          </Link>
        )}
      />
      <Column
        title="Name"
        dataIndex="name"
        key="name"
        render={(_, { id, title, publishDate }) => (
          <Link
            to={`/dashboard/events/${id}`}
            className="flex flex-col justify-start text-left align-start whitespace-nowrap">
            <span className="text-small sm:text-[10px] text-primary">
              #{id}
            </span>
            <h3 className="mt-1 font-semibold text-bold sm:text-base text-darkGrey truncate w-[200px]">
              {title}
            </h3>
            <div className="flex items-center mt-2 text-darkGrey text-small sm:text-sm">
              <CalendarOutlined className="mr-1" />
              <span className="text-xs">Published on {publishDate}</span>
            </div>
          </Link>
        )}
      />
      <Column
        title="Duration"
        dataIndex="duration"
        key="duration"
        render={(_, { duration }) => (
          <div className="flex gap-5">
            <div>
              <h3 className="text-[#4E4E4E] text-small-xs">Starting</h3>
              <p className="text-sm font-bold">{duration.startDate}</p>
              <p className="text-small-xs font-bold">{duration.startTime}</p>
            </div>
            <div>
              <h3 className="text-[#4E4E4E] text-small-xs">Ending</h3>
              <p className="text-sm font-bold">{duration.endDate}</p>
              <p className="text-small-xs font-bold">{duration.endTime}</p>
            </div>
          </div>
        )}
      />
      <Column
        title="Status"
        key="status"
        dataIndex="status"
        render={(_, { status }) => (
          <div className="flex items-center gap-1">
            <div className="w-2 h-2 rounded-full bg-[#0F75BC]" />
            <p className="text-[#0F75BC] text-small-xs">{status}</p>
          </div>
        )}
      />
      <Column
        title=""
        dataIndex="options"
        key="options"
        render={() => <img src={OptionsImg} alt="More Image" className="w-4" />}
      />
    </Table>
  );
};

SingleManifestoTable.propTypes = {
  setSelectedCampaign: PropTypes.func,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
      createdAt: PropTypes.string,
      schedule: PropTypes.shape({
        startDate: PropTypes.string,
        startTime: PropTypes.string,
        endDate: PropTypes.string,
        endTime: PropTypes.string,
      }),
    })
  ),
};

export default SingleManifestoTable;
